<!-- =========================================================================================
    File Name: ChatLog.vue
    Description: Chat Application - Log of chat
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
      <div class="contained-example-container msg-grp-container">
      <div id="div-with-loading" class="vs-con-loading__container" :class="{'activeLoading':chatloader}">
      <div id="component-chat-log" class="m-8" >

        <div v-for="(msgs, indexx) in chatData" class="msg-grp-container" :key="indexx">
            <!-- <div v-for="(msg, index) in msgs" class="msg-grp-container" :key="index"> -->


            <!-- If previous msg is older than current time -->
            <!-- <template v-if="chatData.msg[index-1]">
                <vs-divider v-if="!isSameDay(msg.time, chatData.msg[index-1].time)" class="msg-time">
                    <span>{{ toDate(msg.time) }}</span>
                </vs-divider>
                <div class="spacer mt-8" v-if="!hasSentPreviousMsg(chatData.msg[index-1].isSent, msg.isSent)"></div>
            </template> -->

            <!-- <div class="flex items-start" :class="[{'flex-row-reverse' : msg.isSent}]"> -->
            <div class="flex items-start" :class="[{'flex-row-reverse' :  !getMsgSide(msgs[0].user_id.id)}]">

                <!-- <template v-if="chatData.msg[index-1]">
                    <template v-if="(!hasSentPreviousMsg(chatData.msg[index-1].isSent, msg.isSent) || !isSameDay(msg.time, chatData.msg[index-1].time))">
                        <vs-avatar size="40px" class="border-2 shadow border-solid border-white m-0 flex-shrink-0" :class="msg.isSent ? 'sm:ml-5 ml-3' : 'sm:mr-5 mr-3'" :src="senderImg(msg.isSent)"></vs-avatar>
                    </template>
                </template> -->

                <template>
                   <vs-tooltip v-if="lng === 'dogs' &&  msgs[0].user_id.roles[0].name === 'teacher'" :text="msgs[0].user_id.fname+' '+msgs[0].user_id.lname+' (Staff)'" position="top" >
                    <vs-avatar v-if="msgs[0].user_id.avatar" size="25px" class="border-2 shadow border-solid border-white m-0 flex-shrink-0"  :src="img_cdn+msgs[0].user_id.avatar"></vs-avatar>
                     <vs-avatar v-else size="25px"   ></vs-avatar>
                    </vs-tooltip>
                    <vs-tooltip v-else-if="lng === 'dogs' &&  msgs[0].user_id.roles[0].name === 'user'" :text="msgs[0].user_id.fname+' '+msgs[0].user_id.lname+' (Contact)'" position="top" >
                    <vs-avatar v-if="msgs[0].user_id.avatar" size="25px" class="border-2 shadow border-solid border-white m-0 flex-shrink-0"  :src="img_cdn+msgs[0].user_id.avatar"></vs-avatar>
                    <vs-avatar v-else size="25px"   ></vs-avatar>
                    </vs-tooltip>
                    <vs-tooltip  v-else :text="msgs[0].user_id.fname+' '+msgs[0].user_id.lname+' ('+msgs[0].user_id.roles[0].name.charAt(0).toUpperCase() + msgs[0].user_id.roles[0].name.slice(1)+')'" position="top" >
                    <vs-avatar v-if="msgs[0].user_id.avatar" size="25px" class="border-2 shadow border-solid border-white m-0 flex-shrink-0"  :src="img_cdn+msgs[0].user_id.avatar"></vs-avatar>
                    <vs-avatar  class="border-2 shadow border-solid border-white m-0 flex-shrink-0"  v-else size="25px" ></vs-avatar>
                    </vs-tooltip>

                </template>

                <!-- <template v-if="chatData.msg[index-1]">
                    <div class="mr-16" v-if="!(!hasSentPreviousMsg(chatData.msg[index-1].isSent, msg.isSent) || !isSameDay(msg.time, chatData.msg[index-1].time))"></div>
                </template> -->
<!-- :class="{'bg-primary-gradient text-white': getMsgSide(msg.user_id.id), 'border border-solid border-transparent bg-white': !getMsgSide(msg.user_id.id)}" -->
                <div class="msg break-words relative shadow-md rounded  px-4 mb-2 rounded-lg max-w-sm font-small"  :class="'text-white bg-'+getMsgBackground(msgs[0].user_id.roles[0].name)">
                  <div v-for="(msg, index) in msgs" :key="index">
                    <span v-if="msg.type==='reminder'" style="float:right;margin-left: 50px; font-size: xx-small"><img  src="@/assets/images/pages/bell2.svg" class="responsive w-4 h-4"></span>
                    <span v-html="converter(msg.message)"></span>
                    <vs-row v-for="(file, index ) in msg.attachment" :key="index" >
                    <vs-chip>
                      <a class="text-inherit" target="_blank" :href="file.storage_link">{{file.orignal_name}}</a>
                    </vs-chip>
                    </vs-row>
                  
                   <!-- <ul v-if="msg.attachment.length>0">
                   <li v-for="(file, index ) in msg.attachment" :key="index">
                     <vs-chip><a class="text-inherit" target="_blank" :href="file.storage_link">{{file.orignal_name}}</a></vs-chip>
                  </li>
                  </ul>  -->
                    <!-- <vs-button color="success" type="flat" size="small" target :href="{url: file.storage_link }">{{file.orignal_name}}</vs-button> -->
                
                </div>
                </div>
            </div>
            <!-- </div> -->
        </div> 
          <div class="flex flex-col items-center chat__bg no-scroll-content chat-content-area border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-b-0" v-if="chatData.length===0">
         <h4  class="py-2 px-4 bg-white shadow-md rounded-full cursor-pointer" style="position:fixed;">No Messages</h4>
         </div>
    </div>
      </div> 
    </div>
</template>

<script>
import {
  MARK_AS_READ_CHAT
  
} from '@/graphql'
export default {
  props: {
    user: {
      type: Object,
      value: [Object]
    },
    chat_data:{
      type: Array
    },
    chatloader:{
      type: Boolean
    }
  },
  data () {
    return {
     img_cdn:process.env.VUE_APP_AWS_s3Url+"/",
      meID:'',
      lng:''
    }
  },
  watch:{
    chatloader (val) {
      if (val) {
        this.runloader()
      } else {
        this.$vs.loading.close('#div-with-loading > .con-vs-loading')
      }
    }
  },
  computed: {
    chatData () {
      return this.chat_data
      return this.$store.getters['chat/chatDataOfUser'](this.user)
    },
    chatDatalength () {
      return this.chat_data.length
      return this.$store.getters['chat/chatDataOfUser'](this.user)
    },
    activeUserImg () {
      return this.$store.state.AppActiveUser.photoURL
    },
    senderImg () {
      return (isSentByActiveUser) => {
        if (isSentByActiveUser) return this.$store.state.AppActiveUser.photoURL
        else return this.$store.getters['chat/contact'](this.user).photoURL
      }
    },
    hasSentPreviousMsg () {
      return (last_sender, current_sender) => last_sender === current_sender
    }
  },
  methods: {
    getMsgBackground (value) {
      if (value == 'user' || value == 'contact') {
        return 'primary'
      } else if (value == 'teacher' || value == 'staff') {
        return 'success'
      } else if (value == 'manager') {
        return 'warning'
      } else {
        return 'danger'
      }
      
    },
    converter (value) {
      const urlRegex = /(https?:\/\/[^\s]+)/g
      return value.replace(urlRegex, function (url) {
        return `<b><a class="font-medium" style="color:black;text-decoration: underline"  href="${  url  }" target="_blank">${  url  }</b></a>`
      }) 
    },
    runloader () {
      this.$vs.loading({
        container: '#div-with-loading',
        scale: 0.6
      })
    },
    isSameDay (time_to, time_from) {
      const date_time_to = new Date(Date.parse(time_to))
      const date_time_from = new Date(Date.parse(time_from))
      return date_time_to.getFullYear() === date_time_from.getFullYear() &&
                date_time_to.getMonth() === date_time_from.getMonth() &&
                date_time_to.getDate() === date_time_from.getDate()
    },
    toDate (time) {
      const locale = 'en-us'
      const date_obj = new Date(Date.parse(time))
      const monthName = date_obj.toLocaleString(locale, {
        month: 'short'
      })
      return `${date_obj.getDate()  } ${   monthName}`
    },
    scrollToBottom () {
      this.$nextTick(() => {
        this.$parent.$el.scrollTop = this.$parent.$el.scrollHeight
        // console.log(this.user)
        if (this.meID > 0 && this.user.id > 0) this.markAsRead(this.meID, this.user.id, this.user.__typename)
      })
    },
    getMsgSide (user_id) {
      if (user_id == this.meID) {
        return  false
      } else {
        return  true
      }
    },
    markAsRead (user, student, type) {
      this.$apollo
        .mutate({
          mutation: MARK_AS_READ_CHAT,
          variables: {
            student_id: student,
            user_id: user,
            type
          }
        })
      .then((response) => {
        this.$emit('markread',{"student":student,"type":"student"})
      //  console.log(response)
      })


    }
  },
  updated () {
    this.scrollToBottom()
  },
  mounted () {
    this.scrollToBottom()
    // Listen for the 'NewMessageNotification' event in the 'synchronized' private channel
    this.$echo.channel('synchronized').listen('NewMessageNotification', (payload) => {
      if (payload) {
        if (payload.type === 'student') {
          if (this.user.id === payload.message.student_id) {
            // console.log(payload)
            payload.message.user_id = payload.message.userwithrole
            payload.message.user_id.roles = payload.message.userwithrole['userroles']
            // delete payload.message.userwithrole
            // delete payload.message.user_id.userroles
            // delete payload.message.user_id.roles.pivot
            this.chat_data.push([payload.message])
          }
        } else if (this.user.id === payload.message.program_id) {
          // payload.message.user_id = payload.message.userwithrole
          // payload.message.user_id.roles = payload.message.userwithrole['userroles']
          // // delete payload.message.userwithrole
          // // delete payload.message.user_id.userroles
          // // delete payload.message.user_id.roles.pivot
          // this.chat_data.push(payload.message)
        }
      }   
    })

  },
  created () {
    this.lng = process.env.VUE_APP_I18N_LOCALE
    this.meID = localStorage.getItem('userId');
  }
}
</script>
<style>
/* ul#menu li {
  display:inline;
} */
</style>
